import { ChakraProvider } from "@chakra-ui/react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { setDefaultOptions } from "date-fns"
import frLocale from "date-fns/locale/fr"
import "leaflet/dist/leaflet.css"
import "react-image-gallery/styles/css/image-gallery.css"
import { IntlProvider } from "react-intl"
import "react-phone-number-input/style.css"
import { BrowserRouter, useLocation } from "react-router-dom"
import { AppLanguageContext } from "./context/AppLanguageContext"
import { useAppLanguageContext } from "./context/AppLanguageContext/AppLanguageContext"
import AxiosInterceptors from "./networking/AxiosInterceptors"
import { PrivateRoutes } from "./routing/PrivateRoutes"
import { PublicRoutes } from "./routing/PublicRoutes"
import { isPublicRoute } from "./routing/publicRoutesMap"
import { theme } from "./theme/theme"
import { englishMessages } from "./translations/en/englishMessages"
import { frenchMessages } from "./translations/fr/frenchMessages"

setDefaultOptions({ locale: frLocale })

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
})

function AppContent() {
  const { pathname } = useLocation()
  return isPublicRoute(pathname) ? <PublicRoutes /> : <PrivateRoutes />
}

function AppMain() {
  const { getLang } = useAppLanguageContext()
  const lang = getLang()
  const i18nMessages = lang === "en" ? englishMessages : frenchMessages

  return (
    <IntlProvider locale={lang} messages={i18nMessages}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <AxiosInterceptors>
            <QueryClientProvider client={queryClient}>
              <ReactQueryDevtools initialIsOpen={false} />
              <AppContent />
            </QueryClientProvider>
          </AxiosInterceptors>
        </BrowserRouter>
      </ChakraProvider>
    </IntlProvider>
  )
}

export default function App() {
  return (
    <AppLanguageContext>
      <AppMain />
    </AppLanguageContext>
  )
}
